import Axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api/';

export const fetchNews = async () => {
  try {
    const response = await Axios.get(`${BASE_URL}news/getAll`);
    return response.data?.news || [];
  } catch (err) {
    return [];
  }
};
